import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import { API_BASE_URL } from "views/api"

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

// Sections for this page

const useStyles = makeStyles(styles);

export default function ProductSection(props) {
  const classes = useStyles();
  const [municipality_images, setMunicipalityImages] = React.useState(undefined);
  React.useEffect(() => {
    if (municipality_images === undefined) {
      fetch(API_BASE_URL + 'homepage/municipalities/')
        .then(results => results.json())
        .then(data => {
            setMunicipalityImages(data.results);
        });
    }
  });

  const data_map = {
      suryabinayak : {
        link: `/intro/suryabinayak`,
        name: 'सूर्यविनायक नगरपालिका',
      },
    	madhyapur_thimi : {
        link: `/intro/madhyapur_thimi`,
        name: 'मध्यपुर थिमि नगरपालिका',
      },
    	bhaktapur : {
        link: `/intro/bhaktapur`,
        name: 'भक्तपुर नगरपालिका',
      },
    	changunarayan : {
        link: `/intro/changunarayan`,
        name: 'चाँगुनारायण नगरपालिका',
      }
  }

  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ color: "#134c7a", margin: 0}}>
            <small>परिचय</small>
            {/*props.page === 'ngo' && <span><h3 className={classes.title} style={{ marginTop: '-10px', color: '#134c7a'}}>विभिन्न नगरपालिकामा रहेका गैर सरकारी संस्था</h3></span>*/}
            {/*props.page === 'budget' && <span><h3 className={classes.title} style={{ marginTop: '-10px', color: '#134c7a'}}>बजेट: विभिन्न नगरपालिका</h3></span>*/}
            {/*props.page === 'laws' && <span><h3 className={classes.title} style={{ marginTop: '-10px', color: '#134c7a'}}> कानुन तथा ऐन: विभिन्न नगरपालिका</h3></span>*/}
            {/*props.page === 'project' && <span><h3 className={classes.title} style={{ marginTop: '-10px', color: '#134c7a'}}> योजना तथा परियोजना: विभिन्न नगरपालिका</h3></span>*/}
            {props.page === 'intro' && <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>नगरपालिकाहरू</h3></span>}
            {props.page === 'ddc_intro' && <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>स्थानीय तहहरु: ४ नगरपालीका</h3></span>}
            <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
          </div>

          <GridContainer style={{ backgroundColor: '#fff', margin: '10px' }}>
            {municipality_images && municipality_images.map(municipality_image =>
              {
                let image_url = ''
                if (municipality_image.image !== null) {
                  image_url = municipality_image.image
                }
                return(
                  <GridItem xs={props.vertical?12:10} md={props.vertical?12:2} sm={props.vertical?12:4} style={{ margin: 'auto' }}>
                    <Link to={data_map[municipality_image.name].link}  className={classes.link}>
                      <Card style={{
                        marginBottom: '0', height: '150px',
                        backgroundColor: 'grey', backgroundImage: "url(" + image_url + ")",
                        backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}
                      />
                      <h6 className={classes.description} style={{ color: '#333' }}>{data_map[municipality_image.name].name}</h6>
                    </Link>
                  </GridItem>
                );
              }
            )}
          </GridContainer>
        {props.page === 'intro' && <Button href="/municipality" style={{ margin: 'auto', marginTop: '15px'}} color="primary">थप जानकारी</Button>}
        </GridItem>
      </GridContainer>
    </div>
  );
}
